/** @jsxImportSource @emotion/react */
/** @jsxFrag */
/* eslint-disable react/no-array-index-key */

import { memo } from "react";

import {
  blueBackground,
  blueGreyGradientBackground,
  labelContainer,
  label,
  line,
  lineContainer,
  stepperContainer,
  blueText,
  greyText,
} from "./styles";

interface Step {
  label?: string;
}

interface Props {
  currentStep: number;
  steps: Step[];
}

const Stepper = ({ currentStep, steps }: Props) => {
  const stepCount = steps.length;

  const renderLines = (): JSX.Element[] | undefined => {
    if (stepCount > 1) {
      return Array.from(Array(stepCount - 1).keys()).map((_, i) => {
        const styles = [line];
        if (currentStep === i) {
          styles.push(blueGreyGradientBackground);
        } else if (currentStep > i) {
          styles.push(blueBackground);
        }
        return <div key={`line-${i}`} css={styles} />;
      });
    }
    return undefined;
  };

  const renderLabels = (): JSX.Element[] =>
    steps.map((step, i) => (
      <div key={`label-${i}`} css={[label, i <= currentStep + 1 ? blueText : greyText]}>
        {step.label}
      </div>
    ));

  return (
    <div css={stepperContainer}>
      <div css={lineContainer}>{renderLines()}</div>
      <div css={labelContainer}>{renderLabels()}</div>
    </div>
  );
};

export default memo(Stepper);
